"use client"

import { ApplicationEnvironmentMolecule } from "@/app/env/store"
import { useMolecule } from "bunshi/react"
import { useMemo } from "react"
import { getGachaSolanaConfig } from "./gacha-solana-config"

export function useGachaSolanaConfig() {
  const { bffBaseUrl, gachaSolanaCluster } = useMolecule(
    ApplicationEnvironmentMolecule,
  )

  return useMemo(
    () =>
      getGachaSolanaConfig({
        bffBaseUrl,
        cluster: gachaSolanaCluster,
      }),
    [bffBaseUrl, gachaSolanaCluster],
  )
}
